import axios from 'axios'
import { ElMessage } from 'element-plus'
import { API_CONFIG } from './config'
import store from '@/store'
import router from '@/router'
import { i18n } from '@/i18n'

// 创建axios实例
const service = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: API_CONFIG.TIMEOUT,
  headers: API_CONFIG.HEADERS
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 添加token到请求头
    const token = store.getters['user/token']
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
      console.log('请求携带token:', token)
    }
    
    // 注释掉时间戳参数，因为后端不需要
    // if (config.method === 'get') {
    //   config.params = {
    //     ...config.params,
    //     _t: Date.now()
    //   }
    // }
    
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    console.log('API响应:', res)
    
    // 如果返回的状态码为0，说明接口请求成功
    if (res.code === 0) {
      return res
    } else if (res.code === 10001) {
      ElMessage.error(i18n.global.t('common.deviceOffline'))
      return Promise.reject(new Error(i18n.global.t('common.deviceOffline')))
    } else {
      ElMessage.error(res.msg || i18n.global.t('common.requestFailed'))
      return Promise.reject(new Error(res.msg || i18n.global.t('common.requestFailed')))
    }
  },
  error => {
    console.error('响应错误:', error)
    
    // 处理HTTP错误状态码
    if (error.response) {
      const { status } = error.response
      
      const t = i18n.global.t
      switch (status) {
        case 401:
          ElMessage.error(t('common.loginExpired'))
          store.dispatch('user/logout').then(() => {
            router.push('/login')
          })
          break
        case 403:
          ElMessage.error(t('common.noPermission'))
          break
        case 404:
          ElMessage.error(t('common.notFound'))
          break
        case 500:
          ElMessage.error(t('common.serverError'))
          break
        default:
          ElMessage.error(t('common.networkError'))
      }
    } else {
      ElMessage.error(i18n.global.t('common.networkFailed'))
    }
    
    return Promise.reject(error)
  }
)

export default service
